
export interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  interval: 'month' | 'year';
  description: string;
}

export const IOS_PRODUCT_IDS = {
  MONTHLY: 'mindnote_monthly_subscriptions',
  YEARLY: 'mindnote_yearly_subscriptions'
} as const;

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: IOS_PRODUCT_IDS.MONTHLY,
    name: 'Monthly Plan',
    price: 9.99,
    interval: 'month',
    description: 'Monthly subscription to MindNote Pro'
  },
  {
    id: IOS_PRODUCT_IDS.YEARLY,
    name: 'Yearly Plan',
    price: 100.00,
    interval: 'year',
    description: 'Yearly subscription to MindNote Pro (Save 17%!)'
  }
];

// Extend the subscription type to include all possible states  
export type SubscriptionType = 'monthly' | 'yearly' | 'select' | 'none';
